import { render, staticRenderFns } from "./SidebarSystem.vue?vue&type=template&id=330caff6&scoped=true"
import script from "./SidebarSystem.vue?vue&type=script&lang=js"
export * from "./SidebarSystem.vue?vue&type=script&lang=js"
import style0 from "./SidebarSystem.vue?vue&type=style&index=0&id=330caff6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330caff6",
  null
  
)

export default component.exports